import log from "../utils/log";

export class AdminTransitDisplay {
  init() {
    this.toggleLocationess();
    $("#use_parking_location_for_address").on("change", e => {
      this.toggleLocationess();
    });
  }

  toggleLocationess() {
    if ($("#use_parking_location_for_address").prop("checked")) {
      $(".showOnLocationForAddress").collapse("show");
      $(".showOnManualAddress").collapse("hide");
      $(
        ".showOnLocationForAddress.required input, .showOnLocationForAddress.required select"
      ).attr("required", true);
      $(
        ".showOnManualAddress.required input, .showOnManualAddress.required select"
      ).attr("required", false);
    } else {
      // Have to make parking location blank!
      $("#transit_display_parking_location_id").val("");
      $(".showOnLocationForAddress").collapse("hide");
      $(".showOnManualAddress").collapse("show");
      $(
        ".showOnLocationForAddress.required input, .showOnLocationForAddress.required select"
      ).attr("required", false);
      $(
        ".showOnManualAddress.required input, .showOnManualAddress.required select"
      ).attr("required", true);
    }
  }
}
